module.exports = __webpack_public_path__ + "static/media/FleetLocate_LoginBanners_1.f0290c36.jpg";